function warning(profileLocked) {
    return new Promise((resolve, reject) => {

        if (profileLocked) {
            $.notify('Edits are disabled when user profile is locked.', 'warning');
        } else {
            resolve();
        }
    });
}

export const showProfileLockedWarning = {
    warning
};
